<template>
  <a-modal
    title="不满足投放条件的点位"
    v-model="showModal"
    :footer="null"
    width="864px"
  >
    <div class="modal-content">
      <a-table
        :columns="columns"
        :dataSource="deleDataList"
        :pagination="pagination"
        @change="handlerChange"
      >
        <template slot="name" slot-scope="text">
          <a>{{ text }}</a>
        </template>
      </a-table>

      <div class="modal-footer">
        <a-button
          class="delect-btn"
          size="small"
          @click="deleData"
          >移除全部</a-button
        ><a-button @click="showModal = false">关闭</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { api } from "../../commomFun/api";
export default {
  props: {
    dataSource: Array,
    valiateAdMachineShareData: Object,
    
  },
  data () {
    return {
      showModal: false,
      deleDataList: [],
      pageSize: 5,
      current: 1,
      pagination: {
        defaultCurrent: 5,
        total: 10
      },
      columns: [
        {
          title: "省份-城市-区县",
          key: "areaString",
          dataIndex: "areaString",
          width: 250,
          scopedSlots: {
            customRender: "areaString",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          }
        },
        {
          title: "小区名称",
          key: "communityName",
          dataIndex: "communityName",
          width: 200,
          scopedSlots: {
            customRender: "communityName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          }
        },
        {
          title: "点位名称",
          key: "doorControlName",
          dataIndex: "doorControlName",
          width: 120,
          scopedSlots: {
            customRender: "doorControlName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          }
        },
        {
          title: "终端型号",
          key: "version",
          dataIndex: "version",
          width: 120,
          scopedSlots: { customRender: "version" },
          filters: [
            { text: "QLG19-C215", value: "QLG19-C215" },
            { text: "QLG19-215", value: " QLG19-215" },
            { text: "QLL19-32", value: "QLL19-32" },
            { text: "QLL19-C32", value: "QLL19-C32" },
            { text: "GWS19-49", value: "GWS19-49" },
            { text: 'QLG2020-R8', value: 'QLG2020-R8' }
          ]
        },
        {
          title: "MAC",
          key: "mac",
          dataIndex: "mac",
          width: 150,
          scopedSlots: { customRender: "mac" }
        }
      ]
    };
  },
  methods: {
    handlerChange (val) {
      this.current = val.current;
    },
    deleData () {
      this.$confirm({
        title: "确定要移除全部点位？",
        content: "点击确定后，所有不满足投放条件的点位将被清除",
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          this.pagination.total = 0;
          this.pagination.defaultCurrent = 0;
          this.$parent.delectSelectedPoints();
        }
      });
    },
    valiateAdMachineShare () {
      const pointIds = this.$parent.selectedList.map(item => item.id);
      let {userId, beginTime,endTime,playDuration,playTimes, spaceId} = this.valiateAdMachineShareData;
      let params = {
        userId,
        beginTime,
        endTime,
        playDuration,
        playTimes,
        pointIds,
        spaceId,
        pageSize: this.pageSize,
        pageNum: this.current,
        deliveryPeriod:JSON.parse(sessionStorage.getItem('formItem')).deliveryPeriod || 3 //校验添加播放时段，如果是精准播放则默认是3
      }
      return new Promise((resolve, reject) => {
        api
          .postApi(
            `/select/valiateAdMachineShare`,
            params
          )
          .then(res => {
            const { data, code } = res.data;
            if (code === 200) {
              if(data.length > 0) {
                this.showModal = true;
                const pagination = this.pagination
                pagination.total = data.length
                this.pagination = pagination
                this.deleDataList = data.map(item => {
                  const areaString = `${item.province}-${item.city}-${item.area}`;
                  item.areaString = areaString;
                  return item;
                });
                resolve(false);
              } else {
                resolve(true);
              }
            } else {
              this.$message.error(res.data.msg)
              resolve(false);
            }
          }).catch(() => resolve(false))
      });
    }
  }
};
</script>
<style lange="less" scoped>
/deep/.ant-table-thead > tr,
/deep/ .ant-table-tbody > tr {
  height: 46px;
}

.ant-table-thead > tr > th,
/deep/ .ant-table-tbody > tr > td {
  padding: 0px 8px !important;
}
/deep/ .ant-table-thead > tr > th {
  padding: 0 8px;
}
.delect-btn {
  position: absolute;
  left: 0;
  bottom: 85px;
  left: 0px;
}
.modal-footer {
  position: relative;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
